import { Box, Container, Heading, SimpleGrid } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

const AboutPageHeroSection = () => (
  <Box w="100%" bg="brandGreen.500">
    <Container maxW="8xl" py={{ base: 700, desktop: 1000 }}>
      <SimpleGrid
        columns={{ base: 1, desktop: 2 }}
        alignItems="center"
        spacing={100}
      >
        <Container
          d={{ base: 'block', desktop: 'none' }}
          maxW="3xl"
          mb={500}
          px={200}
        >
          <Heading
            color="neutral.0"
            size={{ base: 600, tablet: 700 }}
            textAlign="center"
            mb={800}
          >
            Our mission is to make home improvement simpler, faster and more
            collaborative.
          </Heading>
        </Container>
        <Container centerContent>
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/about_us_page_hero.png"
            alt="about us hero image"
            width={440}
            objectFit="contain"
          />
        </Container>
        <Heading
          maxW="2xl"
          d={{ base: 'none', desktop: 'block' }}
          color="neutral.0"
          marginBottom={0}
          size={800}
        >
          Our mission is to make home improvement simpler, faster and more
          collaborative.
        </Heading>
      </SimpleGrid>
    </Container>
  </Box>
);

export default AboutPageHeroSection;
